export const classes = {
  "Host": "ClothoAppShellHost",
  "Nav": "ClothoAppShellNav",
  "Brand": "ClothoAppShellBrand",
  "Link": "ClothoAppShellLink",
  "LinkActive": "ClothoAppShellLinkActive",
  "Spacer": "ClothoAppShellSpacer",
  "User": "ClothoAppShellUser",
  "Main": "ClothoAppShellMain",
  "Banner": "ClothoAppShellBanner",
  "Toast": "ClothoAppShellToast",
  "ToastError": "ClothoAppShellToastError",
  "ToastUndo": "ClothoAppShellToastUndo"
} as const;
